import React, {Fragment, useState} from 'react';
import {ButtonBack, ButtonNext, CarouselProvider, Dot, DotGroup, Slide, Slider} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import {RiArrowLeftSLine, RiArrowRightSLine} from "react-icons/ri"
import {makeStyles} from "@mui/styles";
import PropTypes from "prop-types";
import isRequiredIf from 'react-proptype-conditional-require';
import {createStyles} from "@mui/styles";

const styles = makeStyles({

	carouselClassName: {
	},
	sliderClassName: {
		padding: "0 30px 0 30px !important",

	},
	classNameTrayWrap: {
		overflow: "hidden",
		textAlign: "center",
		verticalAlign: "middle"
	},
	classNameTray: {
		// padding: "10px !important"
	},
	innerClassName: {
		padding: "10px",
	}
});

const CardSlider = ({children, visibleSlides, interval, disableButton, hasMasterSpinner, width, height, dotGroup, ...props}) => {
	const [slide, setSlide] = useState(0);
	const styles = makeStyles(props.customStyle)
	const classes = styles();
	const childrenLength = children ? children.length : 0;
	return (
		<React.Fragment>
			<CarouselProvider
				visibleSlides={visibleSlides >= childrenLength ? visibleSlides-1 : visibleSlides}
				totalSlides={childrenLength}
				step={props.step ? props.step:2}
				naturalSlideWidth={width ? width : 200}
				naturalSlideHeight={height ? height : 200}
				currentSlide={slide}
				isPlaying={props.isPlaying}
				infinite={visibleSlides >= childrenLength}
				touchEnabled
				hasMasterSpinner={hasMasterSpinner}
				interval={interval ? interval : 5000}
				className={classes.carouselClassName}

			>
				<div style={{position: "relative", justifySelf: "center", justifyContent: "center", margin: "0 -10px", width: "100%"}}>
					<Slider className={classes.sliderClassName}
							classNameTrayWrap={classes.classNameTrayWrap}
							classNameTray={classes.classNameTray}
					>
						{
							React.Children.map(children, (child, index) => (
								<Slide index={index} innerClassName={classes.innerClassName}>
									{React.cloneElement(child, {})}
								</Slide>
							))

						}
					</Slider>
					{ !disableButton &&
						<Fragment>
							<ButtonBack style={{
								border: "none",
								backgroundColor: "transparent",
								position: "absolute",
								left: 0,
								transform: "translateY(-50%)",
								top: "50%",
							}}
							>
								<RiArrowLeftSLine size={35} color={"#bbb"}/>
							</ButtonBack>
							<ButtonNext
								style={{
									transform: "translateY(-50%)",
									border: "none",
									backgroundColor: "transparent",
									position: "absolute",
									right: 0,
									top: "50%"
								}}
							>
								<RiArrowRightSLine size={35} color={"#bbb"}/>
							</ButtonNext>
						</Fragment>
					}
					{
						dotGroup && <DotGroup className={"dotGroup"}/>
					}
				</div>
			</CarouselProvider>
		</React.Fragment>
	);
};
CardSlider.LABEL_CLASSNAME_ERROR_MESSAGE = 'You must provide a labelClassName when passing down the label prop';

const visibleNumValid = props => props.children.length >= props.visibleSlides;
const responsiveSizesPropTypes = PropTypes.arrayOf(PropTypes.oneOfType([
	PropTypes.number,
	PropTypes.array,
	PropTypes.string,
]));
CardSlider.propTypes = {
	children: PropTypes.any.isRequired,
	visibleSlides: PropTypes.number.isRequired,
	interval: PropTypes.number.isRequired,
	disableButton: PropTypes.bool,
	customStyle: PropTypes.any.isRequired

}
export default CardSlider;
